export default __webpack_public_path__ + "static/media/pelota-basquetbol.3c020d9f.png";